export default "__VITE_ASSET__eOOTTzAW__"